"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CacheProvider = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

// TODO: Fix this file

/* eslint-disable @typescript-eslint/no-explicit-any */
var CacheProvider = /*#__PURE__*/function () {
  function CacheProvider() {
    (0, _classCallCheck2.default)(this, CacheProvider);
    (0, _defineProperty2.default)(this, "cache", {});
  }

  (0, _createClass2.default)(CacheProvider, [{
    key: "set",
    value: function set(key, value) {
      this.cache[key] = value;
    }
  }, {
    key: "clear",
    value: function clear(key) {
      delete this.cache[key];
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.cache = {};
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.cache[key];
    }
  }, {
    key: "getOrDefault",
    value: function () {
      var _getOrDefault = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(key, func) {
        var result, value;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = this.get(key);

                if (!result) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", result);

              case 3:
                _context.next = 5;
                return func();

              case 5:
                value = _context.sent;
                this.set(key, value);
                return _context.abrupt("return", value);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getOrDefault(_x, _x2) {
        return _getOrDefault.apply(this, arguments);
      }

      return getOrDefault;
    }()
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new CacheProvider();
      }

      return this.instance;
    }
  }]);
  return CacheProvider;
}();

exports.CacheProvider = CacheProvider;
(0, _defineProperty2.default)(CacheProvider, "instance", void 0);
(0, _defineProperty2.default)(CacheProvider, "CPP_ORG_CACHE_KEY", "cpp_organization");